import { OnboardingCompanyProfile } from '__generated__/GQL';

/**
 * Formats a company address to put as a check in a "checklist"
 */
const formatCompanyAddress = ({
  city,
  street,
  zip,
}: Pick<OnboardingCompanyProfile, 'street' | 'zip' | 'city'>) =>
  `${street}\n${zip} ${city}`;

export default formatCompanyAddress;
